module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Screwdriver-2e346606ccd8c60433e7c2a417aa557d.svg";